module.exports = __webpack_public_path__ + "img/ads2.cee203ed.jpg";